var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events list_content_tickets_group"},[_c('ol',{staticClass:"w-list-unstyled"},_vm._l((_vm.listTickets),function(ticket,index){return _c('ticket-detail',{key:index,attrs:{"ticket":ticket,"index":index,"selectedIdx":_vm.selectedIdx,"defaultNum":_vm.numOfPax},on:{"change":_vm.changeTicket}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }